import { getApiErrorMessage } from "@timenotes/shared/src/services/api-client"
import { TApiTaskDetails } from "@timenotes/shared/src/services/api-client/types"
import { useArchiveTaskMutation } from "@timenotes/shared/src/services/tasks/queries/use-archive-task-mutation"
import { useDeleteTaskMutation } from "@timenotes/shared/src/services/tasks/queries/use-delete-task-mutation"
import { useRestoreTaskMutation } from "@timenotes/shared/src/services/tasks/queries/use-restore-task-mutation"
import { message, Modal, Tooltip } from "antd"
import { ArchiveSvg, DeleteSvg, MoreSvg } from "assets/svg/icon"
import GenericButtonsList, { TGenericButton } from "components/generic-buttons-list/generic-buttons-list"
import { GenericButtonsListWrapper } from "pages/projects/board/components/styled-components/generic-buttons-list-wrapper"

interface Props {
  projectId: string
  taskId: string
  taskState: TApiTaskDetails['state']
  onDelete?(): any
}

export const TaskOptions = (props: Props) => {
  const {
    projectId,
    taskId,
    taskState,
    onDelete: propsOnDelete,
  } = props

  const isArchived = taskState == "archived"
  const archiveActionTitle = !isArchived ? 'Archive task' : "Restore task"

  const archiveTaskMutation = useArchiveTaskMutation({
    projectId: projectId 
  })

  const restoreTaskMutation = useRestoreTaskMutation({
    projectId: projectId 
  })

  const deleteTaskMutation = useDeleteTaskMutation({
    projectId: projectId
  })

  const onDelete = () => {
    deleteTaskMutation.mutateAsync({
      taskId: taskId,
    }, {
      onSuccess: () => {
        message.success('Task deleted!')
        if (propsOnDelete) propsOnDelete()
      },
      onError: (errors) => {
        message.error(getApiErrorMessage({ errors: errors }, 'base'))
      }
    })
  }

  const onArchive = () => {
    archiveTaskMutation.mutateAsync({
      taskId: taskId,
    }, {
      onSuccess: () => {
        message.success('Task archived!')
      }
    })
  }

  const onUnarchive = () => {
    restoreTaskMutation.mutateAsync({
      taskId: taskId,
    }, {
      onSuccess: () => {
        message.success('Task restored!')
      }
    })
  }

  const statusCallback = isArchived ? onUnarchive : onArchive

  const buttons: TGenericButton[] = [
    {
      title: "",
      icon: MoreSvg,
      type: "text",
      options: [
       {
          title: archiveActionTitle,
          Icon: ArchiveSvg,
          callback: statusCallback,
        },
        {
          title: "Delete task",
          Icon: DeleteSvg,
          callback: () => {
            Modal.confirm({
              onOk: onDelete,
              width: 500,
              okText: "Delete",
              okType: "primary",
              style: { whiteSpace: "pre-line" },
              okButtonProps: { danger: true },
              title: (
                <span style={{ whiteSpace: "nowrap" }}>
                  Are you sure you want to delete this task?
                </span>
              ),
              content:
                "Deleting a task is irreversible! If the task contains time logs, consider archiving it instead.",
            })
          },
        },
      ],
    },
  ]


  return (
    <Tooltip title="More Actions">
      <GenericButtonsList buttons={buttons} />
    </Tooltip>
  )

}